module.exports = __webpack_public_path__ + "static/media/Ios2.ec0dbc7b.png";